export enum Period {
    Previous = 1,
    Current,
    Specific
}